var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInvoice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 1024 1024",
    className: "icon",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M731.21 584.34c-100.99 0-182.86 81.87-182.86 182.86 0 100.99 81.87 182.86 182.86 182.86 100.99 0 182.86-81.87 182.86-182.86 0-100.99-81.87-182.86-182.86-182.86z m0 292.57c-60.5 0-109.71-49.22-109.71-109.71 0-60.5 49.22-109.71 109.71-109.71 60.5 0 109.71 49.22 109.71 109.71 0.01 60.49-49.21 109.71-109.71 109.71z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M752.9 694.05h-43.89v51.2h-51.2v43.89h51.2v51.2h43.89v-51.2h51.2v-43.89h-51.2zM219.58 474.98h219.43v73.14H219.58z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M182.67 365.88H768.3v179.46h73.14V145.21c0-39.96-32.52-72.46-72.48-72.46h-27.34c-29.18 0-55.04 16.71-65.89 42.61-5.68 13.57-27.89 13.55-33.54 0.02-10.84-25.89-36.7-42.62-65.89-42.62h-18.16c-29.18 0-55.04 16.71-65.89 42.61-5.68 13.57-27.89 13.55-33.54 0.02-10.84-25.89-36.7-42.62-65.89-42.62h-17.43c-29.18 0-55.04 16.71-65.89 42.61-5.68 13.57-27.89 13.55-33.54 0.02-10.84-25.89-36.7-42.62-65.89-42.62h-27.59c-39.96 0-72.46 32.5-72.46 72.46v805.14h401.2v-73.14h-328.1l-0.45-511.36z m25.8-222.26c14.29 34.05 47.36 56.05 84.25 56.05 36.91 0 69.98-22.02 82.66-53.79l15.84-2.27c14.29 34.05 47.36 56.05 84.25 56.05 36.91 0 69.98-22.02 82.66-53.79l16.57-2.27c14.29 34.05 47.36 56.05 84.25 56.05 36.91 0 69.98-22.02 82.66-53.79l26.68-0.68V292.7H182.6l-0.13-146.84 26-2.24z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoice);
export default __webpack_public_path__ + "static/media/invoice.cfdd7d80.svg";
export { ForwardRef as ReactComponent };